import { useImpersonation } from "@/contexts/ImpersonationContext";
import { SrIcon } from "@/components/ui/SrIcon";
import { SalesUnitsCard } from "@/components/settings/SalesUnitsCard";
import { CompanyDetailsCard } from "@/components/settings/CompanyDetailsCard";

export default function OrganisasjonSettings() {
  const { activeUser } = useImpersonation();
  const canManageSettings =
    activeUser?.role === "admin" || activeUser?.role === "superadmin";

  if (!canManageSettings) {
    return (
      <div className="page-container">
        <p className="text-sm text-muted-foreground">Du har ikke tilgang.</p>
      </div>
    );
  }

  return (
    <div className="page-container animate-fade-in space-y-6">
      <h1 className="font-display font-semibold text-[clamp(28px,3vw,40px)] tracking-[-0.01em] flex items-center gap-2 mb-6">
        <SrIcon name="building" className="h-6 w-6" />
        Organisasjon
      </h1>
      <CompanyDetailsCard />
      <SalesUnitsCard />
    </div>
  );
}
